
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NightmarkLanding from './NightmarkLanding';
import './NightmarkLanding.css';
import NightmarkLandingNewContent from './NightmarkLanding_newcontent';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NightmarkLanding />} />
        <Route path="/new_content" element={<NightmarkLandingNewContent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
